import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6c0941c2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "text-fa"
};
const _hoisted_2 = {
  class: "text-title"
};
const _hoisted_3 = {
  class: "title-tips"
};
const _hoisted_4 = {
  class: "text-cont-fa"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-title"
}, "实验教学项目负责人情况", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-title"
}, "实验教学项目教学服务团队情况", -1));

const _hoisted_7 = {
  class: "main-person"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tilte"
}, "团队主要成员（含负责人，5人以内）", -1));

const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "other-person"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tilte"
}, "团队其他成员", -1));

const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  class: "sum"
};
const _hoisted_14 = {
  class: "person-sum"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 实验教学项目负责人情况 项目团队总人数： ");

const _hoisted_16 = {
  class: "sum-num"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 人 高校人员数量： ");

const _hoisted_18 = {
  class: "super-num"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 人 企业人员数量： ");

const _hoisted_20 = {
  class: "busi-num"
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 人 ");

const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"remark\" data-v-6c0941c2><div class=\"key-value-li\" data-v-6c0941c2><div class=\"title-dis\" data-v-6c0941c2>注:</div><div class=\"value-dis\" data-v-6c0941c2> 1.教育服务团队成员所在单位需如实填写，可与负责人在同一单位。 </div></div><div class=\"key-value-li\" data-v-6c0941c2><div class=\"title-dis\" data-v-6c0941c2></div><div class=\"value-dis\" data-v-6c0941c2> 2.教育服务团队须有在线教学服务人员和技术支持人员，请在备注中说明。 </div></div></div>", 1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LaborDetailKeyValue = _resolveComponent("LaborDetailKeyValue");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_LaborDetailTitleValue = _resolveComponent("LaborDetailTitleValue");

  const _component_a_table = _resolveComponent("a-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.moudleName), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_hoisted_5, _createVNode(_component_el_row, {
    gutter: 9,
    class: "labor-main-tabpane-li"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_LaborDetailKeyValue, {
        title: "姓名",
        value: $data.teamDetail1.name || '-'
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_LaborDetailKeyValue, {
        title: "性别",
        value: $data.teamDetail1.sex == 1 ? '男' : '女'
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_LaborDetailKeyValue, {
        title: "出生年月",
        value: $data.teamDetail1.birthday ? new Date($data.teamDetail1.birthday).toLocaleDateString() : '-'
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_LaborDetailKeyValue, {
        title: "学历",
        value: $data.teamDetail1.education || '-'
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_LaborDetailKeyValue, {
        title: "学位",
        value: $data.teamDetail1.degree || '-'
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_LaborDetailKeyValue, {
        title: "专业技术职务",
        value: $data.teamDetail1.technical_position || '-'
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_LaborDetailKeyValue, {
        title: "行政职务",
        value: $data.teamDetail1.administrator_position || '-'
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_LaborDetailKeyValue, {
        title: "院系",
        value: $data.teamDetail1.department || '-'
      }, null, 8, ["value"])]),
      _: 1
    })]),
    _: 1
  })]), _createVNode(_component_LaborDetailTitleValue, {
    title: "教学研究情况",
    value: $props.laboratoryItemDetail.study_state || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "学术研究情况",
    value: $props.laboratoryItemDetail.academic_state || '-'
  }, null, 8, ["value"]), _createElementVNode("div", null, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_a_table, {
    border: "",
    columns: $data.columns2,
    "data-source": $data.teamDetail2,
    rowKey: "sortIndex",
    pagination: false
  }, {
    bodyCell: _withCtx(({
      column,
      record,
      index
    }) => [column.dataIndex == 'sortIndex' ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(parseInt(index) + 1), 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["columns", "data-source"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_table, {
    border: "",
    columns: $data.columns3,
    "data-source": $data.teamDetail3,
    rowKey: "sortIndex",
    pagination: false
  }, {
    bodyCell: _withCtx(({
      column,
      record,
      index
    }) => [column.dataIndex == 'sortIndex' ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(parseInt(index) + 1), 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["columns", "data-source"])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", _hoisted_16, _toDisplayString(($data.teamDetail2.length || 0) + ($data.teamDetail3.length || 0)), 1), _hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString($data.teamDetail2 && $data.teamDetail2.length), 1), _hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString($data.teamDetail3 && $data.teamDetail3.length), 1), _hoisted_21]), _hoisted_22])])]);
}